
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import TagEdit from "./tag-edit.vue";
import ApplicationRule from "@/views/tag/components/application-rule.vue";
import {
  StructApplicationRuleV4,
  StructRuleNodeDetailV4,
  StructRuleNodeV4,
  applicationTypeList,
  appRules,
  tagRules,
  useIntList,
  useStringList,
  useRangeList
} from "@/views/tag/components/constant";
import InterviewEdit from "./interview-edit.vue";
import Comment from "@/views/ai-builder/config/commit.vue";
import SetInquiry from "@/components/inquiry/setInquiry.vue";
import AiAsk from "@/components/aiAsk/aiAsk.vue"

import _ from "lodash-es";
import { getRuleValueByRuleType } from "./config";
@Component({
  components: {
    TagEdit,
    InterviewEdit,
    Comment,
    SetInquiry,
    AiAsk,
    ApplicationRule
  }
})
export default class Step5 extends Vue {
  @Prop({}) exam!: ExamV2Custom;
  @Prop({}) isEdit!: boolean;
  title = "admin配置";
  tableData = [];
  visible = false;
  interviewVisible = false;
  form = {};
  subForm = {};
  applicationRule: "" | StructApplicationRuleV4 = new StructApplicationRuleV4();
  created() {
    //
  }
  mounted() {
    const a = this.exam;
    this.tableData = JSON.parse(JSON.stringify(this.exam.applicationRuleList));
  }

  @Watch("exam", { deep: true })
  getTableData(nval: ExamV2Custom) {
    this.tableData = nval.applicationRuleList;
  }

  // 调整排序的最大值
  get sortNumberMax() {
    return this.tableData?.length || 1;
  }

  getRelation(row: any) {
    if (!row?.matchRuleRoot?.mergeType) {
      return "-";
    } else {
      return row?.matchRuleRoot?.mergeType === "AND" ? "且" : "或";
    }
  }

  // 调整规则的顺序
  handleRuleIndexChange(newIndex: number, originalIndex: number) {
    if (newIndex !== originalIndex) {
      this.adjustRulePosition(originalIndex, newIndex);
    }
  }

  adjustRulePosition(fromIndex: number, toIndex: number) {
    // 确保索引在有效范围内
    if (
      fromIndex < 0 ||
      fromIndex >= this.tableData.length ||
      toIndex < 0 ||
      toIndex >= this.tableData.length
    ) {
      return;
    }

    // 移除原位置的规则
    const [rule] = this.tableData.splice(fromIndex, 1);

    // 将规则插入到新位置
    this.tableData.splice(toIndex, 0, rule);

    const tempTableData = JSON.parse(JSON.stringify(this.tableData));

    // 调整排序值
    tempTableData.forEach((item, index) => {
      item.sort = index + 1;
    });

    this.$nextTick(()=>{
      this.tableData = tempTableData;
      this.$emit("change", tempTableData, 'tag');
    })
  }

  addRule(row?: any) {
    this.form = [
      {
        tagForm: {
          mergeType: "AND"
        },
        ruleList: [
          {
            attribute: "",
            relationship: "",
            value: "",
            key: 1,
            dataType: "testResult",
            propName: [],
            dataTypeList: [],
            tagAttrList: []
          }
        ],
        tagApplication: {
          type: "",
          tagSentiment: 0,
          tagDesc: "",
          auditStatus: "",
          sort: "",
          tagStatusList: [],
          subExamId: ""
        },
        key: -1
      }
    ];
    this.applicationRule = this.exam.applicationRuleList || [];
    if (row.type === "级联面试分配") {
      this.editInterview();
    } else {
      this.visible = true;
    }
  }

  handleRuleType(row: any) {
    const tempTypeInfo = [
      row?.type,
      getRuleValueByRuleType(row),
    ]
    return tempTypeInfo.filter(Boolean).join(':');
  }

  getTableDataString() {
    if (!this.tableData?.length) {
      return "";
    }
    return this.tableData.map((row: any) => {
      const tempRowArray = [
        row?.sort || "",
        this.getRelation(row) || "",
        this.getInfo(row)?.replaceAll("\n", ";") || "",
        row?.type ? `${this.handleRuleType(row)}` : "",
        row?.auditDesc || row?.tagName || row?.mokaCustomResult || row?.message || "",
      ]
      return tempRowArray.join("|");
    }).join('\n');
  }

  // 复制全部规则到剪切板
  copyAllRule() {
    if (!this.tableData?.length) {
      return;
    }
    //创建input标签
    const textArea = document.createElement("textarea");
    //将input的值设置为需要复制的内容
    textArea.value = this.getTableDataString();
    textArea.style.position = "fixed";
    textArea.style.background = "transparent";
    textArea.style.boxShadow = "none";
    textArea.style.border = "none";
    textArea.style.outline = "none";
    //添加input标签
    document.body.appendChild(textArea);
    //选中input标签
    textArea.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签.value
    document.body.removeChild(textArea);
    this.$message.success("复制成功");
  }

  modifyOrAddIndex = -1; // -1 代表全部，有意义的索引代表仅仅修改那一条

  // 编辑/查看全部应用规则
  editAllRule(row: ?any) {
    this.modifyOrAddIndex = -1;
    this.addRule(row);
  }

  addOneRule(row?: any) {
    this.modifyOrAddIndex = this.exam.applicationRuleList?.length || 0;
    this.addRule(row);
  }

  editOneRule(row: any, index: number) {
    this.modifyOrAddIndex = index;
    this.addRule(row);
  }

  getInfo(row: any) {
    const arr: any = [];
    row?.matchRuleRoot?.subList?.forEach((el: any) => {
      let san = "";
      let value = "";
      const keys = [
        "cvArgName",
        "dimensionGroupName",
        "dimensionName",
        "paramName",
        "questionId"
      ];
      keys.forEach(key => {
        if (el.detail && el.detail[key]) {
          san += el.detail[key];
        }
      });
      if (
        Array.isArray(el.detail.valueRange) &&
        el.detail.valueRange.length === 2
      ) {
        value =
          "[" + el.detail.valueRange[0] + "," + el.detail.valueRange[1] + ")";
      } else {
        value =
          el.detail.valueInt == 0 || el.detail.valueInt == undefined
            ? el.detail.valueStrings
            : el.detail.valueInt;
      }
      arr.push(
        `${el.detail.attribute}:${san ? san : ""}:${el.detail.relationship
        }:${value}`
      );
    });
    return arr.join("\n");
  }

  editInterview() {
    this.interviewVisible = true;
  }

  editTag(row: any) {
    this.form = row;
  }

  delTag(row: any) {
    this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      const tempTableData = JSON.parse(JSON.stringify(this.tableData));
      const resultTableData = tempTableData.filter((el: any) => {
        if (row.applicationRuleId) {
          return el.applicationRuleId !== row.applicationRuleId;
        } else if (row.applicationKey) {
          return el.applicationKey !== row.applicationKey;
        } else {
          return el.key !== row.key;
        }
      });
      const convertTableData = JSON.parse(JSON.stringify(resultTableData));
      const tempSortedData = convertTableData.map((item: any, index: number)=>{
        return {
          ...item,
          sort: index + 1
        }
      });
      this.tableData = [];
      this.$nextTick(()=>{
        this.tableData = tempSortedData;
      })

      if (row.type === "级联面试分配") {
        this.$emit(
          "change",
          tempSortedData.filter((el: any) => el.type === "级联面试分配")
        );
      } else {
        this.$emit(
          "change",
          tempSortedData.filter((el: any) => el.type !== "级联面试分配"),
          "tag"
        );
      }
      this.$message({
        type: "success",
        message: "删除成功!"
      });
    });
  }

  async ok(param?: any, type?: string) {
    //todo 一些校验可以在这里做
    await this.checkData();
    const convertParam = JSON.parse(JSON.stringify(param));
    this.tableData = convertParam;
    this.$emit("change", convertParam, type);
  }

  //关闭
  close() {
    this.$emit("close", "xxx");
  }
  //离开前校验
  async checkData() {
    return new Promise((resolve, reject) => {
      //do something
      resolve(true);
      // reject(false);
    });
  }
}
